// TODO: Clean up component usage and parent settings layout and auth props?
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import type { MemberAttribute } from '@di-devs/member-feature-plugin/shared'
import { isProtectedMemberAttribute } from '@di-devs/member-feature-plugin/shared'
import { useBetterFeatureClient } from '@di-devs/utils-fe'
import { Button, Flex } from 'antd'
import type { HookAPI } from 'antd/es/modal/useModal'
import { useState } from 'react'
import { TapAnimationComponent } from '@/components'
import type { FeatureClient } from '@/config/client'
import { useDeleteMemberAttribute } from '@/queries'
import MemberAttributeEditAlertModal from './MemberAttributeEditAlertModal'

const MemberAttributeTableActions = ({
	memberAttribute,
	modalInstance,
	showMemberAttributeDetailModal,
}: {
	memberAttribute: MemberAttribute
	modalInstance: HookAPI
	showMemberAttributeDetailModal: (value: MemberAttribute | undefined) => void
}) => {
	const [isAlertModalVisible, setIsAlertModalVisible] = useState(false)
	const reactFeatureClient = useBetterFeatureClient<FeatureClient>()
	const deleteMemberAttribute = useDeleteMemberAttribute(
		reactFeatureClient,
		memberAttribute?.memberAttributeId,
	)
	const isProtectedAttribute = isProtectedMemberAttribute(memberAttribute)

	const handleEditClick = () => {
		if (isProtectedAttribute) {
			return
		}

		const attributeType = memberAttribute.type

		if (['select', 'checkbox', 'radio'].includes(attributeType)) {
			setIsAlertModalVisible(true)
		} else {
			showMemberAttributeDetailModal(memberAttribute)
		}
	}

	const MemberAttributeEditButton = () => (
		<Button icon={<EditOutlined />} onClick={handleEditClick} disabled={isProtectedAttribute}>
			編集
		</Button>
	)
	const MemberAttributeDeleteButton = () => (
		<Button
			danger
			icon={<DeleteOutlined />}
			disabled={isProtectedAttribute}
			onClick={() => {
				modalInstance.confirm({
					title: '確認',
					icon: <ExclamationCircleOutlined className='text-red-600' />,
					content: (
						<p>
							<span className='text-red-600'>「{memberAttribute?.label || ''}」</span>
							を削除してもよろしいでしょうか？
						</p>
					),
					okText: '削除',
					okButtonProps: {
						size: 'large',
						type: 'primary',
						danger: true,
					},
					cancelText: '閉じる',
					cancelButtonProps: {
						size: 'large',
					},
					centered: true,
					onOk() {
						memberAttribute?.memberAttributeId &&
							deleteMemberAttribute.mutate(memberAttribute.memberAttributeId)
					},
				})
			}}
		>
			削除
		</Button>
	)
	return (
		<>
			<Flex gap={10} justify='center'>
				<TapAnimationComponent>
					<MemberAttributeEditButton />
				</TapAnimationComponent>
				<TapAnimationComponent className='ml-1'>
					<MemberAttributeDeleteButton />
				</TapAnimationComponent>
			</Flex>

			<MemberAttributeEditAlertModal
				visible={isAlertModalVisible}
				onClose={() => setIsAlertModalVisible(false)}
				showMemberAttributeDetailModal={showMemberAttributeDetailModal}
				memberAttribute={memberAttribute}
			/>
		</>
	)
}

export default MemberAttributeTableActions
